<template>
    <section id="kickstarter-draft">
        <b-modal 
            id="processing-kickstarter-draft" 
            ref="processingKickstarterDraft"
            @hide = "hideModal"
            centered
            hide-header hide-footer>
            <div class="d-flex justify-content-center align-items-center">
                <div class="popup-content text-center position-relative">
                    <button
                        @click="hideModal"
                        aria-label="Close"
                        class="close pr-2"
                        id="close-button">
                            <CloseCross/>
                    </button>
                    <div class="p-5">
                        <Icon icon = "kickstarter-green" width="70"/>
                        <p class="desc-text p2n text-center c18">
                            <span v-if="hasNoManageCommunityAccess && !kickstarterDraftUrl">
                                We don't have <b>"Manage community"</b> permission to create your update draft.
                                <br>
                                Please change your permissions to "Manage community" from your Kickstarter page.
                            </span>
                            <span v-else-if="draftInProcess">We are creating your Kickstarter update draft. <br>
                            We'll send a notification whenever it's ready.</span>
                            <span v-else-if="kickstarterDraftUrl">
                                Your draft is already created! <br>
                                You can find it using 
                                <a 
                                    :href="kickstarterDraftUrl" 
                                    @click="toKickstarter('KS Draft Link Clicked')"
                                    target="_blank"
                                    class="c1 draft-link"
                                >this link</a></span>
                        </p>
                        <Button 
                            v-if="hasNoManageCommunityAccess && ksManageCollabsUrl && !kickstarterDraftUrl" 
                            class="py-3" 
                            style="padding: 0"
                            data-type="pendings-modal" 
                            @click.native="toKickstarter('KS Change Permissions Clicked')">
                            <a 
                                :href="ksManageCollabsUrl" 
                                target="_blank"
                                class="c1 ks-link"
                            >Change permissions</a>
                        </Button> 
                        <Button v-else class="py-3" data-type="pendings-modal" @click.native="hideModal">Cool!</Button>  
                    </div>
                </div>
            </div>
        </b-modal>
       
    </section>
</template>

<script>
import {mapState} from 'vuex'
import Icon from '../components/Theme/Icon'
import {CloseCross} from '../components/Icons'
import Button from '../components/Theme/Button'
import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue";

export default {
    data(){
        return {
            kickstarterDraftUrl: null,
            hasNoManageCommunityAccess: false,
            draftInProcess: false
        }
    },
    mounted() {
        this.kickstarterDraftUrl = this.modals['processing-kickstarter-draft'].kickstarterDraftUrl
        this.hasNoManageCommunityAccess = this.modals['processing-kickstarter-draft'].hasNoManageCommunityAccess
        this.ksManageCollabsUrl = this.modals['processing-kickstarter-draft'].projectUrl ?  this.modals['processing-kickstarter-draft'].projectUrl + '/collaborators?ref=creator_nav' : null
        this.draftInProcess = this.modals['processing-kickstarter-draft'].draftInProcess
        this.$bvModal.show(`processing-kickstarter-draft`)
    },
    computed: {
        ...mapState(['modals']),
    },
    components: {
        Icon,
        CloseCross,
        Button,
        LottieAnimation
    },
    methods: {
        hideModal(){
            this.$bvModal.hide('processing-kickstarter-draft');
            setTimeout(() => {
                this.$store.commit('TOGGLE_MODAL', ['processing-kickstarter-draft', false]);
                if(!this.kickstarterDraftUrl && !this.hasNoManageCommunityAccess) {
                    this.$router.push('/').catch(() => {})
                }
            }, 100)
        },
        toKickstarter(eventName){

            const eventInfo = this.modals['processing-kickstarter-draft'].eventInfo

            if(!eventInfo) return;

            const {campaignName, updateId, updateDate} = eventInfo
            
            this.$ga.event('Post Update', eventName, `
                Campaign: ${campaignName},
                UpdateDateId: ${updateId},
                UpdateDate: ${updateDate}
            `)

            this.$sendMixpanelEvent(eventName, {
                'Campaign Name': campaignName,
                'Update Date Id': updateId,
                'Update Date': updateDate
            });
        },
    }
}
</script>

<style lang="scss" scoped>
    @import '../assets/scss/variables';

    // styles for lottie animation 
    // .animation-img {
    //     height: 90vh;
    //     margin: 0 auto;
    //     min-width: 320px;
    //     display: block;
    //     width: 50vh;
    //     background-size: cover;
    //     position: absolute;
    //     top: 0;
    //     z-index: 1000000;
    // }

    .popup-content {
        background-color: #f4f4f4;
        max-width: 720px;
        width: 100%;
        border-radius: 10px;
    }

    .desc-text {
        line-height: 26px;
        margin: 26px 0 32px;
    }

    .draft-link {
        cursor: pointer;
    }

    .ks-link {
        color: #ffffff!important;
        padding: 12px 96px 12px 96px
    }

</style>